import { useCallback } from "react";
import { CURRICULUM } from "@/lib/curriculum";
import { MOODS, SCENES, posterFor } from "@/lib/journey";
import { ShareCardDialog, cardBase } from "@/components/ShareCard";

export const drawModuleCard = async (moduleId, firstName) => {
  const mod = CURRICULUM.find((m) => m.id === moduleId);
  const { canvas, ctx: x } = await cardBase(posterFor(moduleId));
  x.fillStyle = "#F59E0B";
  x.font = "30px 'Courier New', monospace";
  x.fillText(`M O D U L E   ${mod.n}   ·   D O N E`, 540, 860);
  x.fillStyle = "#FFFFFF";
  x.font = "84px Georgia, serif";
  x.fillText(mod.title, 540, 960);
  x.fillStyle = "#78716C";
  x.font = "24px Georgia, serif";
  x.fillText(`${MOODS[moduleId]} · ${SCENES[moduleId]}`, 540, 1020);
  x.fillStyle = "#F59E0B";
  x.font = "italic 40px Georgia, serif";
  x.fillText(`— ${firstName} went through it.`, 540, 1120);
  return canvas;
};

export const ModuleShareDialog = ({ open, onOpenChange, moduleId, firstName }) => {
  const mod = CURRICULUM.find((m) => m.id === moduleId);
  const draw = useCallback(() => drawModuleCard(moduleId, firstName), [moduleId, firstName]);
  if (!mod) return null;
  return (
    <ShareCardDialog
      open={open}
      onOpenChange={onOpenChange}
      draw={draw}
      testId="module-share"
      title={`Module ${mod.n} · done. Tell someone.`}
      description="Your milestone card, with this module's scene behind it."
      fileName={`TACC-module-${mod.n}-done.png`}
      shareText={`Module ${mod.n} · ${mod.title} — done. Through Adversity Comes Change. tacc.love`}
    />
  );
};
